export const AVANCE_CONTABLE_MODULE_ID = 'avance_contable'

export const ROLES_DEFAULT_AVANCE_CONTABLE = ['ADMIN', 'COLABORADOR', 'SUPER_COLABORADOR']

export function defaultAvanceContableAccess(roles) {
  return (roles || []).some((r) => ROLES_DEFAULT_AVANCE_CONTABLE.includes(r))
}
